<template>
  <v-dialog
    persistent
    v-bind="[$attrs, $props]"
    width="auto"
    content-class="modal-image-profile__content"
  >
    <img
      :src="imageItem"
      :alt="altPhoto"
      class="modal-image-profile__img-hidden"
      style="object-fit: contain; width: 100%; height: 100%"
      id="imageZoom"
      v-if="!show"
    />
    <div class="modal-image-profile__div" v-else>
      <v-zoomer :style="style" ref="zoomer" :max-scale="5">
        <img
          :src="imageItem"
          :alt="altPhoto"
          class="modal-image-profile__img"
          :style="styleImg"
        />
      </v-zoomer>
      <BaseButton
        type-button="tertiary"
        @click="$emit('close')"
        class="modal-image-profile__button"
      >
        <img src="@/assets/close.svg" alt="close" />
      </BaseButton>
    </div>
  </v-dialog>
</template>
<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import { ProfileUser, MiniProfile } from "../../modules/profile/types";
import { mixins } from "vue-class-component";
import { ModalMixin } from "../../mixins/ModalMixin";
@Component
export default class ModalImageProfile extends mixins(ModalMixin) {
  @Prop(Object) profile: ProfileUser | MiniProfile;
  @Prop(Object) img: any;
  style = "";
  show = false;
  styleImg = "";
  get imageItem(): any {
    return this.profile
      ? this.profile.profileImage
      : this.img.blob || this.img.mediaUrl || this.img.url;
  }
  get altPhoto(): string {
    return `${this.$t("misc.photo")}`;
  }
  mounted(): void {
    this.style = `width: auto; height: auto; overflow: hidden;`;
    this.styleImg = `width: auto; height: 80vh; overflow: hidden; object-fit: contain;`;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
}
</script>
<style lang="sass">
.modal-image-profile__
  &div
    position: relative
  &button
    position: fixed
    top: 40px
    right: 20px
    @media (max-width: 600px)
      top: 80px
    border-radius: 50% !important
    height: 20px !important
    width: 20px !important
  &img
    max-width: 100%
    width: 100%
  &img-hidden
    opacity: 0 !important
  &content
    position: relative !important
    overflow: hidden
</style>
